import { Component, ElementRef, Input, OnInit, ViewChild } from '@angular/core';
import { ConfigServiceService } from 'src/app/services/config-service.service';
import { SpecificationService } from 'src/app/services/specification.service';
import { UserService } from 'src/app/services/user.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'calsoft-certificate-no2',
  templateUrl: './certificate-no2.component.html',
  styleUrls: ['./certificate-no2.component.scss']
})
export class CertificateNo2Component implements OnInit {
  @Input() product: any;
  @Input() imageUrl: any;
  @Input() data: any;
  storeName: any;
  streetAddress: any;
  streetAddressLine2: any;
  vatNumber: any;
  hsnNumber: any;
  pancardNo: any;
  enableGst: any;
  zipPostCode: any;
  email: any;
  storePhoneNumber: any;
  invoiceTemplateId: any;
  amountInWords: string;
  @ViewChild('htmlData', { static: false }) htmlData: ElementRef;
  certificateBackgroundImg: any;
  courseManagerSign: any;
  certificateEnablePercentage: any;

  @Input() Lecture: any;

  LectureDetails: any;

  username: any;

  constructor(
    private configService: ConfigServiceService,
    private specificationService : SpecificationService,
    private userService: UserService,
  ) {

  }
  public serverPath = environment.commonImageApi + "certificateBackgroundImg/";

  public serverPath1 = environment.commonImageApi + "courseManagerSign/";

  public LecturerServerPath = environment.commonImageApi + '/lecturer/';

  ngOnInit() {
    this.getConfigData();

    this.username = this.userService.getAuthenticatedUser();

    if(this.Lecture!=null){
      this.getLecturerById();
    }
  }      
  
  getConfigData() {
    this.configService.getConfigData()
      .subscribe(
        data => {
          this.data=data;
          this.courseManagerSign = this.data['courseManagerSign'];
          this.certificateBackgroundImg = this.data['certificateBackgroundImg'];
          this.certificateEnablePercentage = this.data['certificateEnablePercentage']
        }, error => {

        }
      );
  }

  getLecturerById() {
    this.specificationService.getLecturerById(this.Lecture)
      .subscribe(res => {
 
           this.LectureDetails = res;
   
           console.log(this.LectureDetails);
           
   
         },
         error => {
         }
       )
  }
    
}
